import React from "react";
import { CommonEmptyContentBlock } from "../CommonEmptyContentBlock";

export const ResetFiltersBlock = ({ text, onResetClick }) => {
	return (
		<CommonEmptyContentBlock
			iconClass="icon-hearts"
			title={text.OOPS}
			description={text.OOPS_TEXT}
			onActionButtonClick={onResetClick}
			actionButtonText={text.RESET_FILTERS}
		/>
	);
};
